module.exports = __webpack_public_path__ + "static/img/maskCount_blue.15ac0fd5.png";